import React from 'react'
import literals from '../config/literals.json'
import AppContext from '../contexts/AppContext'

export default function useLocale() {
	const { locale } = React.useContext(AppContext)

	const l = React.useCallback(key => {
		return literals[locale][key] || key
	}, [locale])

	return {
		l,
	}
}
